/* eslint-disable */
"use client";

import * as React from "react";
import createIcon from "../Icon/createIcon";
export default createIcon( /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  d: "M10.382 3.615a1.616 1.616 0 0 1 3.23 0v7.554c0 .115.094.208.209.208h2.215a.808.808 0 0 1 .61 1.338l-4.039 4.646a.808.808 0 0 1-1.22 0l-4.039-4.646a.808.808 0 0 1 .61-1.338h2.215a.208.208 0 0 0 .209-.208V3.615Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M19.875 17.122c0-.558.452-1.01 1.01-1.01a1.009 1.009 0 0 1 1.013 1.01v1.545A3.333 3.333 0 0 1 18.566 22H5.428A3.333 3.333 0 0 1 2.1 18.667v-1.545a1.01 1.01 0 0 1 2.02 0v1.545a1.31 1.31 0 0 0 1.308 1.308h13.138a1.31 1.31 0 0 0 1.309-1.308v-1.545Z"
})), "0 0 24 24", "Download");